import React from 'react';
import TransportActions from '../actions/TransportActions';
import TransportStore from '../stores/TransportStore';
import MonthListItem from './MonthListItem';
import AuthStore from '../stores/AuthStore';

function getMonthListItem(month, key) {
  return (
    <MonthListItem
      key={key}
      month={month}
    />
  );
}

class MonthsComponent extends React.Component {

  constructor() {
    super()
    this.state = {
      months: []
    }
    this.onChange = this.onChange.bind(this)
  }

  componentWillMount() {
    TransportStore.addChangeListener(this.onChange)
  }

  componentDidMount() {
    TransportActions.recieveMonths(AuthStore.getUser().id)
  }

  componentWillUnmount() {
    TransportStore.removeChangeListener(this.onChange)
  }

  onChange() {
    this.setState({
      months: TransportStore.getMonths()
    });
  }

  render() {
    let monthListItems;
    if (this.state.months) {
      monthListItems = this.state.months.map((month, key) => getMonthListItem(month, key))
    }
    return (
      <div>
        <h1>
          <div className="breadcrumb">
              <span>Miesiące</span>
          </div>
        </h1>
        <div className="project-list">
          {monthListItems}
        </div>
      </div>
    );
  }
}

export default MonthsComponent



// WEBPACK FOOTER //
// ./src/components/Months.js